import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://ee02b59e7409e66a7078fb37ade6a9e8@o111889.ingest.us.sentry.io/4508258890416128",
  debug: false,
  environment: import.meta.env.PUBLIC_VERCEL_ENV,
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 1,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});